import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ChatMenuComponent } from './chat-menu.component'
import { RouterModule } from '@angular/router'

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [ChatMenuComponent],
  exports: [ChatMenuComponent],
  providers: [],
})
export class ChatMenuModule {}
